module.exports = __webpack_public_path__ + "img/product-preview-46.8d5b03a.png";